$(function ($) {
    $(document).on('change', '[data-product-counter] input', function (e) {
        e.preventDefault();

        const el = $(this)
        const product = el.closest('[data-product-item]')
        const subtotal = product.find('[data-product-subtotal]')
        const total = $('[data-total]')
        const btn = $('[data-checkout-btn]')
        const removeBtns = $('[data-product-remove]')
        const counterBtns = $('[data-product-counter]')
        const product_key = product.data('key');
        const quantity = el.val();

        product.addClass('item--loading')
        total.addClass('item--loading')
        btn.addClass('disabled')
        removeBtns.addClass('disabled')
        counterBtns.addClass('disabled')

        try {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'update_cart_quantity_and_get_total',
                    product_key: product_key,
                    quantity: quantity
                },
                success: function (response) {
                    if (!response || response.error)
                        return;

                    let result = JSON.parse(response)

                    if (!result.cart_count)
                        window.location.reload()

                    if (result.cart_count)
                        $('[data-header-cart-quantity]').show().html(`<span>${result.cart_count}</span>`)

                    product.removeClass('item--loading')
                    total.removeClass('item--loading')
                    btn.removeClass('disabled')
                    removeBtns.removeClass('disabled')
                    counterBtns.removeClass('disabled')

                    if (result.product_total)
                        subtotal.html(result.product_total)

                    if (result.cart_total)
                        $('[data-total-value]').html(result.cart_total)
                }
            });
        } catch (e) {
            product.removeClass('item--loading')
            total.removeClass('item--loading')
            btn.removeClass('disabled')
            removeBtns.addClass('disabled')
            counterBtns.addClass('disabled')
        }

    });
});
